/* Do not edit manually. This file generated by common-deploy/localize/upload.js */

import { registerLocaleData } from '@angular/common';
import localeEN from '@angular/common/locales/en';
import localeRU from '@angular/common/locales/ru';
import localeES from '@angular/common/locales/es';
import localeIT from '@angular/common/locales/it';
import localePL from '@angular/common/locales/pl';
import localeFR from '@angular/common/locales/fr';
import localeDE from '@angular/common/locales/de';
import localeJA from '@angular/common/locales/ja';
import localeKO from '@angular/common/locales/ko';
import localePT from '@angular/common/locales/pt';
import localeUK from '@angular/common/locales/uk';

export function registerAllLocalesData() {
  registerLocaleData(localeEN, 'en');
  registerLocaleData(localeRU, 'ru');
  registerLocaleData(localeES, 'es');
  registerLocaleData(localeIT, 'it');
  registerLocaleData(localePL, 'pl');
  registerLocaleData(localeFR, 'fr');
  registerLocaleData(localeDE, 'de');
  registerLocaleData(localeJA, 'ja');
  registerLocaleData(localeKO, 'ko');
  registerLocaleData(localePT, 'pt');
  registerLocaleData(localeUK, 'uk');
}
